module.exports = __webpack_public_path__ + "img/Pfade_Tabea_2.66b53dca.png";